import { useLocation } from "react-router";
import { employeeShellFor, isEmployeePath } from "@/routes/employeePaths";
import { useEmployeeGate } from "./useEmployeeGate";

/**
 * Is the page shown in skyEmployee's chrome? Its own pages always; a shared
 * page opened from it (`?from=employee`, e.g. Users & access) only while
 * skyEmployee is on — the same rule as the sidebar (AppLayout) and the header
 * logo (TenantLogo).
 */
export function useEmployeeChrome(): boolean {
  const { pathname, search } = useLocation();
  const { enabled } = useEmployeeGate();
  return isEmployeePath(pathname) || employeeShellFor(pathname, search, enabled);
}
